import Bowser from "bowser";

const bowser = Bowser.getParser(window.navigator.userAgent);

/**
 * Currently required features (considering Chrome Desktop and Android as minimum)
 * - EventSource - Chrome 26
 *    (https://developer.mozilla.org/en-US/docs/Web/API/EventSource#browser_compatibility)
 * - indexedDb - Chrome 25
 *    (https://developer.mozilla.org/en-US/docs/Web/API/indexedDB#browser_compatibility)
 * - Material UI v4 - Chrome 49
 *    (https://v4.mui.com/getting-started/supported-platforms/)
 * - LocalStorage - Chrome 18
 *    (https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage#browser_compatibility)
 * - Service worker - Chrome 49
 *    (https://jakearchibald.github.io/isserviceworkerready/)
 * - SessionStorage - Chrome 18
 *    (https://developer.mozilla.org/en-US/docs/Web/API/Window/sessionStorage#browser_compatibility)
 * - SubtleCrypto (Secure context required) - Chrome 60
 *    (https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto#browser_compatibility)
 * - WebSockets - Chrome 18
 *    (https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API#browser_compatibility)
 * - WebUSB (Thermal printing) - Chrome 61
 *    (https://developer.mozilla.org/en-US/docs/Web/API/USB#browser_compatibility)
 */
export function isValidBrowserVersion(): boolean {
  return bowser.satisfies({ chrome: ">=61" });
}
